import React from 'react';

const AnimatedImage = () => {
  return (
    <div
      id="container"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh',
        background: 'transparent'
      }}
    >
      <img
        src="/A.png"
        alt="A Image"
        style={{
          width: '800px',
          height: '800px',
          objectFit: 'contain',
          marginTop: '200px',
          animation: 'moveX 3s infinite ease-in-out'
        }}
      />
    </div>
  );
};

export default AnimatedImage;
